export interface IEnhancedLeadershipDesignationModel {
  id: number;
  code: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  sequence: number;
}
